import { sendMessage } from 'api/inbox';
import { EMessageSenderType, EMessageType, TMessage, TServerMessage } from 'types/inbox';
import { getTimeStr } from './calendar';
import dayjs from './dayjs';

//todo

export const unitAndSortServerMessages = (serverMessages?: TServerMessage[]): TServerMessage[] | undefined => {
    if (!serverMessages) {
        return serverMessages;
    }
    const ret = [...(serverMessages || [])];
    ret.sort((a, b) => {
        return dayjs(a.createdAt).isBefore(dayjs(b.createdAt)) ? -1 : 1;
    });
    //去重
    const keys: string[] = [];
    const uniqueMessages: TServerMessage[] = [];
    for (const message of ret) {
        if (!keys.includes(message.sortKey)) {
            keys.push(message.sortKey);
            uniqueMessages.push(message);
        }
    }
    return uniqueMessages;
};

export const handleServerSideMessage = (serverMessages?: TServerMessage[], unreadMessageCount?: number): TMessage[] | undefined => {
    const keys: string[] = [];
    const ret: TMessage[] = [];
    let lastTimeLabel = '';
    let lastSendType = '';
    if (!serverMessages) {
        return serverMessages;
    }
    const showUnreadLabel = !!(unreadMessageCount && unreadMessageCount > 0);
    let targetUnread = unreadMessageCount || 0;

    for (let i = serverMessages.length - 1; i >= 0; i--) {
        const serverMessage = serverMessages[i];
        if (serverMessage.senderType !== EMessageSenderType.PROVIDER) {
            targetUnread = targetUnread - 1;
            if (targetUnread === 0) {
                targetUnread = i;
                break;
            }
        }
    }



    for (let i = 0; i < serverMessages.length; i++) {
        const serverMessage = serverMessages[i];
        if (keys.includes(serverMessage.sortKey)) {
            //去重
            return;
        }
        keys.push(serverMessage.sortKey);
        if (showUnreadLabel && targetUnread === i) {
            ret.push({
                messageId: serverMessage.messageId,
                conversationId: serverMessage.conversationId,
                senderId: serverMessage.senderId,
                senderType: EMessageSenderType.SYSTEM,
                receiverId: serverMessage.receiverId,
                receiverType: serverMessage.receiverType,
                replyToMessageId: serverMessage.replyToMessageId,
                visibleTo: serverMessage.visibleTo,
                // sortKey: serverMessage.sortKey,
                createdAt: serverMessage.createdAt,
                updatedAt: serverMessage.updatedAt,
                messageType: EMessageType.UNREAD_MARK,
                sortKey: 'unread',
            });
        }
        const timeLabel = serverMessage.createdAt ? getTimeStr(dayjs(serverMessage.createdAt), 'MMMM DD, YYYY') : ''; //March 3, 2024
        if (!lastTimeLabel || lastTimeLabel !== timeLabel) {
            lastTimeLabel = timeLabel;
            ret.push({
                messageId: serverMessage.messageId,
                conversationId: serverMessage.conversationId,
                senderId: serverMessage.senderId,
                senderType: EMessageSenderType.SYSTEM,
                receiverId: serverMessage.receiverId,
                receiverType: serverMessage.receiverType,
                replyToMessageId: serverMessage.replyToMessageId,
                visibleTo: serverMessage.visibleTo,
                // sortKey: serverMessage.sortKey,
                createdAt: serverMessage.createdAt,
                updatedAt: serverMessage.updatedAt,

                messageType: EMessageType.TIME_LABEL,
                timeLabel,
                sortKey: timeLabel,
            });
            //if has time label, need show send time in next message
            lastSendType = '';
        }
        let showSendTime = false;
        if (!lastSendType || lastSendType !== serverMessage.senderType) {
            showSendTime = true;
            lastSendType = serverMessage.senderType;
        }
        const addMessage: TMessage = {
            messageId: serverMessage.messageId,
            conversationId: serverMessage.conversationId,
            senderId: serverMessage.senderId,
            senderType: serverMessage.senderType,
            receiverId: serverMessage.receiverId,
            receiverType: serverMessage.receiverType,
            replyToMessageId: serverMessage.replyToMessageId,
            visibleTo: serverMessage.visibleTo,
            sortKey: serverMessage.sortKey,
            createdAt: serverMessage.createdAt,
            updatedAt: serverMessage.updatedAt,
            messageType: serverMessage.messageType,
        }
        if (serverMessage.messageType === EMessageType.TEXT) {
            //"content": "{\"body\":\"Thank you for reaching out. I am Evan, your healthcare provider. How can I assist you today?\"}",
            const jsonStr = serverMessage.content;
            try {
                const textObject: { body: string } = JSON.parse(jsonStr);
                addMessage.text = {
                    body: textObject.body
                }
            } catch (e) {
                console.error(e)
            }
        } else if (serverMessage.messageType === EMessageType.APPOINTMENT) {
            //"{\"type\":\"NEW_APPOINTMENT_CREATED\",\"id\":458,\"appointmentName\":\"Infections: Prescription service\",\"providerId\":1417,\"clientId\":106531,\"startAt\":\"2025-05-30T03:25\",\"duration\":101,\"contactType\":\"in-person\",\"appointmentStatus\":\"scheduled\",\"reason\":\"\",\"scheduledBy\":\"klarity-booked\",\"serviceType\":\"Prescription service\",\"serviceSpecialty\":\"Infections\",\"serviceState\":\"CA\",\"createdAt\":\"2025-05-28T00:41:47.322\"}"
            const jsonStr = serverMessage.content;
            try {
                const appointmentObject = JSON.parse(jsonStr);
                addMessage.appointment = appointmentObject
            } catch (e) {
                console.error(e)
            }
        } else if (serverMessage.messageType === EMessageType.QUESTION) {
            //{ "subject": "xxxxxx", "body": "xxxxxxx", }
            const jsonStr = serverMessage.content;
            try {
                const questionObject = JSON.parse(jsonStr);
                addMessage.question = questionObject;
            } catch (e) {
                console.error(e);
            }

        } else if (serverMessage.messageType === EMessageType.AVA_REPLY) {
            //"{     \"body\": \"The quick brown fox jumps over the lazy dog while the sun rises quietly behind the distant mountains, painting the sky with shades of orange and pink.\",     \"llm_message_id\": \"123123123123\",     \"feed_back\": \"\" }",
            const jsonStr = serverMessage.content;
            try {
                const replyObject = JSON.parse(jsonStr);
                addMessage.avaReply = replyObject;
            } catch (e) {
                console.error(e);
            }
        } else if (serverMessage.messageType === EMessageType.EMAIL) {
            //{\"receiver\":\"john.doe@example.com\",\"subject\":\"Re: From kiwi health\",\"providerEmailId\":33207,\"body\":\"[[SNET]]Thank you for your message! It seems that your inquiry is still related to updates in Asana, which I am unable to assist with, as it falls outside my healthcare expertise. However, if you have any health-related questions or concerns, I would be more than happy to help you with those.\\n\\nIf you're looking to discuss your health needs or have other inquiries, please feel free to schedule an appointment with me through this link: [Book an Appointment](https://dev.d2ysjydukc4efk.amplifyapp.com/provider/lxc). Alternatively, you can reach us at vf-1234 for immediate assistance.\\n\\nI look forward to supporting you with your healthcare needs!\",\"sender\":\"Jianguo.tang@helloklarity.com\"}
            const jsonStr = serverMessage.content;
            try {
                const emailObject = JSON.parse(jsonStr);
                addMessage.email = emailObject;
            } catch (e) {
                console.error(e);
            }
        }
        ret.push({ ...addMessage, showSendTime });
    }

    return ret;
};
